import { gql } from "@apollo/client";

export const CHECK_PROMO_QUERY = gql`
  query CheckPromo($code: String!) {
    checkPromoCode(code: $code) {
      id
      code
      discount
      discount_type
      duration
      is_active
    }
  }
`;
